import { List } from '../../components/list';

/**
 * __Menu list__
 *
 * An [unordered list](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/ul) with visual styles removed,
 * for semantically grouping list items.
 */
export var MenuList = List;